import { get } from "lodash-es";
import { computed, unref } from "vue";

import { getHotelBrandLogo } from "@/utils/hotel";

export enum EHotelBrandsTypesId {
  others = "6699c8fb5a09a65fda534d2e"
}

export const useHotelBrandLogo = hotel => {
  const hotelLogo = computed(() => {
    return getHotelBrandLogo(unref(hotel));
  });

  const statisticsLogo = computed(() => {
    const brand = get(unref(hotel), "_biz.charmdeerRawRender.shopBrand");

    if (!brand || brand._id === EHotelBrandsTypesId.others) {
      return "";
    }

    return brand?.imageDetail?.statisticsLogo;
  });

  const mapLogo = computed(() => {
    const brand = get(unref(hotel), "_biz.charmdeerRawRender.shopBrand");
    if (!brand || brand._id === EHotelBrandsTypesId.others) {
      return "";
    }

    return brand?.imageDetail?.mapLogo;
  });
  const mapLogoHighlighted = computed(() => {
    const brand = get(unref(hotel), "_biz.charmdeerRawRender.shopBrand");
    if (!brand || brand._id === EHotelBrandsTypesId.others) {
      return "";
    }

    return brand?.imageDetail?.mapLogoHighlighted;
  });
  return {
    hotelLogo,
    statisticsLogo,
    mapLogoHighlighted,
    mapLogo
  };
};
